module.exports = __webpack_public_path__ + "static/media/26.35ea2b4f.jpg";